export default __webpack_public_path__ + "static/media/GooglePartners.581fe0c4.png";